import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
// import OperatorEdit from './operator-edit'
import AntennaList from './antenna-list'
import AntennaAdd from './antenna-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Antenna = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.ANTENNA}
                        component={AntennaList}
                    />
                    {/* <Route
                        exact
                        path={ROUTES.OPERATOR_EDIT}
                        component={OperatorEdit}
                    /> */}
                    <Route
                        exact
                        path={ROUTES.ANTENNA_ADD}
                        component={AntennaAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Antenna)



// WEBPACK FOOTER //
// ./src/pages/antenna/index.js